import React, { useEffect, useState } from 'react'
import "./styles.css"
import Navbar from "../../components/Navbar"
import { Button, Container, Row, Spinner } from 'reactstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { IJob } from "../../redux/types"
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { Col } from 'react-bootstrap'
import CustomButton from "../../components/CustomButton"
import { useAppDispatch, useAppSelector } from "../../redux/store"
import { deleteJob, getAllJobs, getJobById } from '../../redux/slices/jobSlice'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import useWindowSize from '../../utils/useWindowSize'
import { useTranslation } from 'react-i18next'

export default function JobDetail() {

    const location = useLocation()
    const navigate = useNavigate()

    const dispatch = useAppDispatch()

    const currentJob: IJob = useAppSelector(state => state.job.currentJob)
    const accessToken = useAppSelector(state => state.auth.accessToken)

    const [width, _] = useWindowSize()

    const { i18n, t } = useTranslation()

    const handleDelete = () => {
        dispatch(deleteJob(currentJob._id))
        navigate(-1)
        setTimeout(() => {
            dispatch(getAllJobs())
        }, 1000);
    }

    useEffect(() => {
        dispatch(getJobById(location.pathname.split("/")[location.pathname.split("/").length - 1]))
    }, [])

    return (
        <div className='job-detail'>
            <Container>
                <Navbar />
                <Row className='job-row-area' style={{ position: "relative" }}>
                    {width > 700 && (<Button className='back-btn' onClick={() => navigate(-1)} style={{ position: "absolute", top: "5px", left: "5px" }}><div className='arrow-btn-back me-2'><ArrowBackIcon className='btn-icon ' /></div><span className='ps-4'>{i18n.language === "tr" ? "Geri Dön" : "Back"}</span></Button>)}

                    {!currentJob ? <div style={{ height: "60vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Spinner color='info' />
                    </div> : (
                        <>
                            <div className='job-detail-header'
                                style={{ width: width < 700 ? "95%" : "60%" }}
                            >
                                <h4 style={{ fontSize: width < 700 ? "18px" : "" }}>{currentJob.title}</h4>

                                <h5 style={{ fontSize: width < 700 ? "16px" : "" }}><BusinessOutlinedIcon fontSize={width < 700 ? "small" : "medium"} className='me-2' />{currentJob.firm}</h5>
                                <h5 style={{ fontSize: width < 700 ? "16px" : "" }}><LocationOnOutlinedIcon fontSize={width < 700 ? "small" : "medium"} className='me-2' />{currentJob.location}</h5>

                                <h5>{currentJob.jobType}</h5>

                                <CustomButton isLoading={false} label={i18n.language === "tr" ? 'Başvur' : "Apply"} className='my-4' onClick={() => navigate(location.pathname + "/apply")} />
                            </div>
                            <div className='job-description'>
                                <h4 style={{ fontSize: width < 700 ? "18px" : "" }}>{t('jobDescription')}</h4>


                                <ul style={{ fontSize: width < 700 ? "14px" : "" }} >{currentJob.jobDefinition}</ul>



                            </div>

                            {currentJob.jobCriteria?.length && currentJob.jobCriteria.length > 0 && (
                                <div className='criteria'>
                                    <h4 style={{ fontSize: width < 700 ? "18px" : "" }}>{t("criteria")}</h4>
                                    <div >
                                        {currentJob.jobCriteria.map((criteria) => {
                                            return (
                                                <p style={{ fontSize: width < 700 ? "14px" : "" }}><span style={{ fontSize: "20px", fontWeight: "600", display: "inline", marginRight: "10px" }}>·</span>{criteria}</p>

                                            )
                                        })}

                                    </div>
                                </div>
                            )}
                            {accessToken && (
                                <div style={{ marginTop: "30px", display: "flex", justifyContent: "center" }}>
                                    <Button onClick={handleDelete} size='lg' color='danger' >İlanı Sil</Button>
                                </div>
                            )}
                        </>
                    )}

                </Row>
            </Container>
        </div>
    )
}
